import { createSmartrrModal } from "@vendor-app/utils/createModalStore";

export const useSequentialDeleteFlowModal = createSmartrrModal<{}>();
